import { Page } from 'layouts/Page';
import { FC } from 'react';
import { ShopifyDevApp } from 'components/ShopifyDevApp';

export const ShopifyDevAppPage: FC = () => {
	return (
		<Page title="Shopify Dev App – EAS Dashboard">
			<ShopifyDevApp />
		</Page>
	);
};
